var validateEmail = function(){
	var event = function(){
		document.getElementById("btnSubmit").addEventListener("click", function(e){
			e.preventDefault();
			var theResult = true;
			var str = document.getElementById('Email').value;
	        	var filter = /^([\w-&+\'\.]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z\-]{2,24}(?:\.[a-z\-]{2})?)$/i;
	        	var htmlInfo = '<div class="ErrorMsgPanel text15 validation-summary-errors textDkRed" role="alert" aria-atomic="true"><p class="paddingTop15 textBold marginLeft10 validationHeading textDkRed">Oops! Some of the information you entered is not correct.</p><ul></u></div>';
	        	if (!filter.test(str)) {
				document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);	
				document.getElementsByClassName('infoText')[0].insertAdjacentHTML('afterend', htmlInfo);
	            		document.getElementById('Email').style.backgroundColor = '#ffd9d9';
	            		document.getElementsByClassName('ErrorMsgPanel')[0].getElementsByTagName("ul")[0].appendChild('<li>Email</li>');
	            		return false;
	        	} 
		});
	},
	runFilter = function(e){
		var filter = /^([\w-&+\'\.]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z\-]{2,24}(?:\.[a-z\-]{2})?)$/i;
   		return filter.test(e);
	};
	/*function ValidateEmail(e){
   		var filter = /^([\w-&+\'\.]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z\-]{2,24}(?:\.[a-z\-]{2})?)$/i;
   		return filter.test(e);
   	}*/
   	
   	return {
   		event: event,
   		runfilter: runfilter
   	};
};